import React, { useContext, useEffect } from "react";

import { FormProvider, useForm } from "react-hook-form";

import { DepositLimitFormType } from "@data-types";
import { DepositContext } from "@state/context/payment/DepositContext";
import { LimitSteps } from "@utils/limits/limitSteps";
import { LimitType } from "@utils/limits/limitType";
import { observer } from "mobx-react";

import DepositLimitDailyLimit from "./DepositLimitDailyLimit";
import DepositLimitFooter from "./DepositLimitFooter";
import DepositLimitMonthlyLimit from "./DepositLimitMonthlyLimit";
import DepositLimitWeeklyLimit from "./DepositLimitWeeklyLimit";

export default observer(function DepositLimitIncreaseLimit() {
	const depositStore = useContext(DepositContext);

	const methods = useForm<DepositLimitFormType>({
		mode: "onChange",
		defaultValues: {
			amount:
				depositStore.depositLimitStore.limitData?.userLimits[0]
					?.gamingLimitDuration.abrv == LimitType.MONTHLY_LIMIT
					? 10000
					: null,
			lossAmount:
				depositStore.depositLimitStore.limitData?.userLimits[1]
					?.gamingLimitDuration.abrv == LimitType.MONTHLY_LIMIT
					? depositStore.depositLimitStore.limitData?.userLimits[1]
							?.amount
					: null,
		} as Partial<DepositLimitFormType>,
	});

	useEffect(() => {
		const limitData = depositStore.depositLimitStore.limitData;

		if (limitData) {
			const monthlyLimit =
				limitData.userLimits[0].gamingLimitDuration.abrv ===
				LimitType.MONTHLY_LIMIT;

			methods.reset({
				amount: monthlyLimit ? 10000 : null,
				lossAmount: monthlyLimit
					? limitData.userLimits[1]?.amount
					: null,
			} as Partial<DepositLimitFormType>);
		}
	}, [depositStore.depositLimitStore.limitData]);

	if (
		depositStore.depositLimitStore.activeStep !== LimitSteps.INCREASE_LIMIT
	) {
		return null;
	}

	return (
		<>
			<FormProvider {...methods}>
				<form
					onSubmit={methods.handleSubmit(
						depositStore.depositLimitStore.onSuccess
					)}
				>
					<div className="popup__body">
						<DepositLimitDailyLimit />

						<DepositLimitWeeklyLimit />

						<DepositLimitMonthlyLimit />
					</div>

					<DepositLimitFooter />
				</form>
			</FormProvider>
		</>
	);
});
